import { useCheckLocationArchivable } from './hooks/useCheckLocationArchivable'
import { useCreateLocation } from './hooks/useCreateLocation'
import { useDeleteOneLocation } from './hooks/useDeleteOneLocation'
import { useFetchAllLocations } from './hooks/useFetchAllLocations'
import { useFetchFranchises } from './hooks/useFetchFranchises'
import { useFetchOneLocation } from './hooks/useFetchOneLocation'
import { useUpdateOneLocation } from './hooks/useUpdateOneLocation'
import {
  invalidateAllLocations,
  invalidateLocationOne
} from './location.queryKeys'

class LocationService {
  location = {
    useCheckArchivable: useCheckLocationArchivable,
    useFetchAll: useFetchAllLocations,
    useCreate: useCreateLocation,
    useFetchOne: useFetchOneLocation,
    useDeleteOne: useDeleteOneLocation,
    useUpdate: useUpdateOneLocation,
    invalidate: {
      one: invalidateLocationOne,
      all: invalidateAllLocations
    }
  }

  franchises = {
    useFetch: useFetchFranchises
  }
}

export const locationService = new LocationService()
